<template>
  <div class="text-overflow" :style="{ '-webkit-line-clamp': clamp }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    clamp: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="less" scoped>
.text-overflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
